import { render, staticRenderFns } from "./PendingApprovalOtherLoanModal.vue?vue&type=template&id=517298fc"
import script from "./PendingApprovalOtherLoanModal.vue?vue&type=script&lang=js"
export * from "./PendingApprovalOtherLoanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports